(() => {
  const menus = () => [...document.querySelectorAll('.ev-menu-group')];
  document.addEventListener('toggle', event => {
    const element = event.target;
    if (element instanceof HTMLDetailsElement && element.matches('.ev-menu-group') && element.open) {
      menus().forEach(other => { if (other !== element) other.open = false; });
    }
    if (element instanceof HTMLDetailsElement && element.matches('.ev-mobile-menu')) {
      document.body.style.overflow = element.open ? 'hidden' : '';
      if (element.open) element.querySelector('.ev-menu-close')?.focus();
    }
  }, true);
  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('.ev-menu-close')) {
      const menu = target.closest('.ev-mobile-menu');
      if (menu) { menu.open = false; menu.querySelector('summary')?.focus(); }
    }
    menus().forEach(menu => { if (!menu.contains(target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    const mobile = document.querySelector('.ev-mobile-menu[open]');
    if (event.key === 'Escape') {
      menus().forEach(menu => { menu.open = false; });
      if (mobile) { mobile.open = false; mobile.querySelector('summary')?.focus(); }
    }
    if (event.key === 'Tab' && mobile) {
      const controls = [...mobile.querySelectorAll('.ev-mobile-panel a,.ev-mobile-panel button,.ev-mobile-panel summary')].filter(el => el.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });

  const welcome = document.querySelector('[data-ev-welcome]');
  if (welcome instanceof HTMLDialogElement) {
    const closeWelcome = () => { welcome.close(); try { localStorage.setItem('ev-welcome-dismissed', String(Date.now())); } catch {} };
    welcome.querySelectorAll('.ev-welcome-close,.ev-welcome-dismiss').forEach(button => button.addEventListener('click', closeWelcome));
    welcome.addEventListener('cancel', event => { event.preventDefault(); closeWelcome(); });
    welcome.addEventListener('click', event => { if (event.target === welcome) { const rect = welcome.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeWelcome(); } });
    let dismissed = 0; try { dismissed = Number(localStorage.getItem('ev-welcome-dismissed') || 0); } catch { dismissed = Date.now(); }
    if (!document.documentElement.classList.contains('shopify-design-mode') && Date.now() - dismissed > 30 * 86400000) {
      setTimeout(() => { if (!document.querySelector('dialog[open],.ev-mobile-menu[open]')) welcome.showModal(); }, Number(welcome.dataset.delay) || 8000);
    }
  }
  const recent = async () => {
    const section = document.querySelector('[data-ev-recent]');
    if (!section) return;
    const handle = section.dataset.productHandle;
    const key = 'ev-recent-products';
    let previous = [];
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      if (Array.isArray(value)) previous = value.filter(v => typeof v === 'string' && /^[a-z0-9-]+$/.test(v)).slice(0, 12);
      localStorage.setItem(key, JSON.stringify([handle, ...previous.filter(v => v !== handle)].slice(0, 12)));
    } catch { return; }
    const handles = previous.filter(v => v !== handle).slice(0, 4);
    if (!handles.length) return;
    const root = window.Shopify?.routes?.root || '/';
    const currency = window.Shopify?.currency?.active || 'USD';
    const format = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency });
    const items = await Promise.all(handles.map(async item => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(item)}.js`, { credentials: 'same-origin' });
        return response.ok ? await response.json() : null;
      } catch { return null; }
    }));
    const grid = section.querySelector('[data-ev-recent-grid]');
    items.filter(Boolean).forEach(item => {
      const card = document.createElement('a'); card.className = 'ev-product-card'; card.href = `${root}products/${item.handle}`;
      const imageWrap = document.createElement('div'); imageWrap.className = 'ev-card-image';
      if (item.featured_image) { const img = document.createElement('img'); img.src = item.featured_image; img.alt = item.title; img.loading = 'lazy'; img.width = 500; img.height = 500; imageWrap.append(img); }
      const title = document.createElement('h3'); title.textContent = item.title;
      const price = document.createElement('p'); price.className = 'ev-card-price'; price.textContent = format.format(item.price / 100);
      card.append(imageWrap, title, price); grid.append(card);
    });
    section.hidden = !grid.children.length;
  };
  recent();
})();

// Hover opens desktop dropdowns; event delegation also supports theme-editor reloads.
(() => {
  const desktopHover = '(min-width:769px) and (hover:hover) and (pointer:fine)';
  document.addEventListener('pointerover', event => {
    if (!(event.target instanceof Element) || !matchMedia(desktopHover).matches) return;
    const menu = event.target.closest('[data-ev-hover="true"] .ev-menu-group');
    if (menu && !menu.contains(event.relatedTarget)) {
      document.querySelectorAll('.ev-desktop-navigation .ev-menu-group[open]').forEach(other => { if (other !== menu) other.open = false; });
      menu.open = true;
    }
  });
  document.addEventListener('pointerout', event => {
    if (!(event.target instanceof Element) || !matchMedia(desktopHover).matches) return;
    const menu = event.target.closest('[data-ev-hover="true"] .ev-menu-group');
    if (menu && !menu.contains(event.relatedTarget)) menu.open = false;
  });
})();

(() => {
  const drawer = document.getElementById('ev-mobile-drawer');
  if (!(drawer instanceof HTMLDialogElement)) return;
  let trigger;
  let previousOverflow = '';
  const close = () => { if (drawer.open) drawer.close(); };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const openButton = event.target.closest('[data-ev-menu-open]');
    if (openButton) {
      trigger = openButton;
      if (!drawer.open) {
        previousOverflow = document.body.style.overflow;
        drawer.showModal();
        document.body.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded', 'true');
        drawer.querySelector('[data-ev-menu-close]')?.focus();
      }
    }
    if (event.target.closest('[data-ev-menu-close]')) close();
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }
  });
  drawer.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    document.querySelectorAll('[data-ev-menu-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    drawer.querySelectorAll('details[open]').forEach(group => { group.open = false; });
    if (trigger?.isConnected) trigger.focus();
  });
  matchMedia('(min-width:769px)').addEventListener('change', event => { if (event.matches) close(); });
})();
